export const Rights = [
    "WEB_MODULE_MY_HISTORY_READ"
]
